import PropertyCardContent from './PropertyCardContent';

export default PropertyCardContent;
